(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userAccessRequestService', userAccessRequestService);

    /* @ngInject */
    function userAccessRequestService($http,
        $q,
        exception,
        logger,
        coreService,
        moment,
        config,
        $odataresource,
        $odata, $rootScope) {

        var count = 0;
        var service = {
            getPendingUserTableConfig: getPendingUserTableConfig,
            getProcessedUserTableConfig: getProcessedUserTableConfig,
            getTableConfig: getTableConfig,
            getODataResource: getODataResource,
            getAccessRequests: getAccessRequests,
            getDefualtAccessRequestUser: getDefualtAccessRequestUser,
            getMockedPendingUser: getMockedPendingUser,            
            getMockedPendingUserCount: getMockedPendingUserCount,
            saveAccessRequest: saveAccessRequest,
            updateCount: updateCount
        };

        activate();

        return service;

        function activate() {
        }

        function updateCount(newCount) {
            count = newCount;
        }

        function getMockedPendingUserCount() {                        
            $rootScope.$emit('updatePendingUsersBadgeCount', count);
            return count;            
        }

        function getMockedPendingUser(isProcessed) {            
            var pendingUsers = (isProcessed) ? [{
                LegacyUserId: 0,
                LegacySourceSystemId: 29,
                FirstName: 'Joe',
                LastName: 'Blow',
                FullName: 'Joe Blow',
                Email: 'joeblow@test.com',
                Customer: 'Waste Management',
                JobTitle: 'Sales Team Agent',
                LegacyApplication: 'SCAR',
                Status: true
            }] : [];
            return function () { return $q.when(pendingUsers); };
        }

        function getDefualtAccessRequestUser() {
            var onBoardUser = {
                user:
                {
                    UserId: 0,
                    ConnectionTypeId: 2,
                    Email: '',
                    IsActive: true,
                    FullName: '',
                    AssignedUserId: 0,
                    InviteEmailSent: false,
                    DateCreated: moment().toDate(),
                    UpdatedUserId: 0,
                    DateUpdated: moment().toDate(),
                    Deleted: false
                },
                settings:
                {
                    roleName: 'Corporate',
                    isAdmin: false,
                    RoleId: 11,
                    CorporateId: 0,
                    RegionId: 0,
                    AreaId: 0,
                    SiteId: 0
                },
                applications: []
            };
            return angular.copy(onBoardUser);
            
        }

        function getTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'FullName',
                        displayName: 'Full Name',
                        ODataKey: 'FullName',
                        type: 'match'
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match'
                    },
                    {
                        id: 'CorporateName',
                        displayName: 'Corporate Name',
                        ODataKey: 'CorporateName',
                        type: 'match'
                    },
                    {
                        id: 'SupervisorName',
                        displayName: 'Supervisor Name',
                        ODataKey: 'SupervisorName',
                        type: 'match'
                    },
                    {
                        id: 'Address',
                        displayName: 'Address',
                        ODataKey: 'Address',
                        type: 'match'
                    },
                    {
                        id: 'TruckVins',
                        displayName: 'Truck Vins',
                        ODataKey: 'TruckVins',
                        type: 'match'
                    },
                    {
                        id: 'DateCreated',
                        displayName: 'Date Created',
                        ODataKey: 'DateCreated',
                        type: 'date'
                    },
                    {
                        id: 'IsAccepted',
                        displayName: 'Is Accepted',
                        ODataKey: 'IsAccepted',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Accepted'
                            },
                            off: {
                                className: 'danger',
                                display: 'Not Accepted'
                            }
                        }
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getPendingUserTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'FullName',
                        displayName: 'Full Name',
                        ODataKey: 'FullName',
                        type: 'match'
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match'
                    },
                    {
                        id: 'Customer',
                        displayName: 'Customer',
                        ODataKey: 'Customer',
                        type: 'match'
                    },
                    {
                        id: 'LegacyApplication',
                        displayName: 'Legacy Application',
                        ODataKey: 'LegacyApplication',
                        type: 'match'
                    },
                    {
                        id: 'JobTitle',
                        displayName: 'Job Title',
                        ODataKey: 'JobTitle',
                        type: 'match'
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getProcessedUserTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'FullName',
                        displayName: 'Full Name',
                        ODataKey: 'FullName',
                        type: 'match'
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match'
                    },
                    {
                        id: 'Customer',
                        displayName: 'Customer',
                        ODataKey: 'Customer',
                        type: 'match'
                    },
                    {
                        id: 'LegacyApplication',
                        displayName: 'Legacy Application',
                        ODataKey: 'LegacyApplication',
                        type: 'match'
                    },
                    {
                        id: 'JobTitle',
                        displayName: 'Job Title',
                        ODataKey: 'JobTitle',
                        type: 'match'
                    },
                    {
                        id: 'Status',
                        displayName: 'Status',
                        ODataKey: 'Status',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Accepted'
                            },
                            off: {
                                className: 'danger',
                                display: 'Rejected'
                            }
                        }
                    }
                ],
                actions: []
            };
            return tableConfig;
        }
        
        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/AccessRequests',
                {},
                {},
                {
                    odatakey: 'AccessRequestId',
                    isodatav4: true
                });
        }

        function getAccessRequests(tableState) {
            var query = service.getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query,
                    tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'DateCreated', reverse: true
            };
            coreService.processODataSort(query, tableState.sort);

            return query
                .expand('CreatedUser')
                .expand('AdminUser')
                .withInlineCount()
                .query()
                .$promise;
        }

        function saveAccessRequest(accessRequest) {
            return coreService.httpAccountsPost('AccessRequest', accessRequest);
        }
    }
})();
